var colors = {
  lightGreyGreenThree: '#cdebd2',
  lightGreyGreenFour: '#c3e0c8',
  darkBlueGreen: '#004b46',
  paleGrey: '#f0f1f2',
  paleGreyThree: '#f5f6f7',
  paleGreyTwo: '#f5f8f8',
  pinkishGrey: '#cccccc',
  sageLight: '#d7f7dd',
  black: '#000000',
  white: '#ffffff',
  whiteTwo: '#f2f2f2',
  whiteThree: '#f7f7f7',
  whiteFour: '#e6e6e6',
  silver: '#ebeced',
  silverFour: '#e3e4e5',
  warmGrey: '#999999',
  watermelon: '#ff4d6a',
  watermelonTwo: '#ff4b69',
  salmonPink: '#ff6780',
  darkishPink: '#e6455f',
  green: '#17b831',
  lavenderBlush: '#fff1f3',
  greenLight: '#E1EAEA',
  greyGreen: '#99b7b5',
  reddishPink: '#ff3377',
  zircon: '#e0e9e9',
  blackRussian: '#1A1A2C',
  blackRussian05: 'rgba(26, 26, 44, 0.5)',
  blackRussian06: 'rgba(26, 26, 44, 0.6)',
  ghostWhite: '#F7F7FF',
  magentaLight: '#cd68ff',
  vanillaIce: '#CFCFE6',
  wildWatermelon: '#FF6982',
  quicksilver: '#A3A3AB',
  brinkPink: '#FF6982',
  pineGreen: '#00736B',
  lightBluishGreen: '#AFFAB3',
  paleTara: 'rgba(215, 253, 217, 0.22)',
  silverChalice: '#B2B2B2',
  primaryMain: '#DA1F2A',
  dark100: '#A8B1B7',
  dark200: '#6D778B',
  dark300: '#363A47',
  primaryAction: '#C53038',
  light200: '#F9F9F9',
  light300: '#F2F2F2',
  light400: '#E0E0E0',
  field100: '#F9FBFF',
  field200: '#F1F3F9',
  field300: '#D8DDEC',
  informationLink: '#1390DF',
  warning400: '#F2994A',
  warning300: '#FFC438'
};
export default colors;